enum TriggerGroupType {
  General = 0,
  Response = 1,
  FlowEnd = 2,
}

export default TriggerGroupType;
